var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 571,
    height: 303,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M60 0h511v13H60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 53h551v13H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M60 106h451v13H60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M60 159h451v13H60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 212h511v13H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0.058
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.227
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M31 7h11v92H31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M31 7h11v92H31z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M244.75 293.02c137.57-40.56 270.38 45.3 250.43-95.43C475.23 56.86 367.34 8.32 259 .37c-67.5-4.96-63.83 40.04-96.2 58.56C113.18 87.32 62 104.44 62 156.66c0 86.3 45.2 176.92 182.75 136.36z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#CBCBCB",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M61 1v11h509V1H61z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#CBCBCB",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M1 54h549v11H1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#CBCBCB",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M61 107h449v11H61z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#CBCBCB",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M61 160v11h449v-11H61z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#CBCBCB",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M1 213h509v11H1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M51.5 140.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51 132)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M51.5 85.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3V85.05c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51 77)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M51.5 30.05v89.84h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3V30.05c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51 22)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M122.5 195.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122 187)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M122.5 140.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122 132)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M212.5 195.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 187)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M212.5 140.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 132)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M283.5 195.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 187)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M212.5 85.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3V85.05c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 77)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M212.5 30.05v89.84h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3V30.05c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 22)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M283.5 140.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 132)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M283.5 85.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3V85.05c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 77)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M283.5 30.05v89.84h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3V30.05c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 22)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M374.5 140.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374 132)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M445.5 195.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(445 187)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M445.5 140.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3v-89.84c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(445 132)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M374.5 85.06v89.83h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3V85.05c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374 77)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4D29",
    stroke: "#111",
    strokeWidth: 2,
    d: "M374.5 30.05v89.84h8.33c7.45-6.28 14.75-6.28 21.9 0h11.05c7.23-6.55 14.26-6.55 21.1 0h8.3V30.05c-5.38-4.7-10.62-7.06-15.73-7.06-7.66 0-10.96 3.65-14.48 7.05h-9.32c-4.22-4.7-9.6-7.05-16.1-7.05-5.58 0-10.6 2.35-15.04 7.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374 22)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#x"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 2,
    d: "M32 8v90h9V8h-9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5ab474972f13d92335a71d6f585bc2de.svg";
export { ForwardRef as ReactComponent };